var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),(_vm.loadingCount > 0)?_c('div',{staticClass:"global-loading"},[_c('van-loading',{attrs:{"size":"24px","vertical":""}},[_vm._v("加载中...")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }